var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgModalBackground = function SvgModalBackground(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 119,
    viewBox: "0 0 446 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipRule: "evenodd",
    stroke: "#A38026",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-47 54.912 266.456-199.398 273.479 199.6v209.478l-273.48 197.584L-47 264.793V54.912Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-36.121 59.115 255.719-191.333L482.057 59.309v201.005l-262.46 189.592-255.718-189.399V59.115Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-25.244 63.32 244.982-183.268L471.177 63.505v192.532l-251.44 181.601-244.981-181.416V63.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.365 67.523 219.88-107.679 460.3 67.701V251.76L219.879 425.369-14.365 251.937V67.523Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.486 71.728 220.023-95.41 449.422 71.897v175.586L220.022 413.1-3.486 247.652V71.728Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39 75.93 220.164-83.14l218.38 159.232v167.113L220.162 400.83 7.391 243.366V75.931Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.27 80.135 220.304-70.871l207.36 151.16v158.639L220.304 388.561 18.269 239.081V80.135Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.146 84.34 220.446-58.603 416.786 84.484v150.167L220.444 376.292 29.147 234.796V84.339Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.025 88.543 220.587-46.333 405.908 88.679v141.694L220.587 364.022 40.025 230.51V88.543Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.904 92.747 220.73-34.063 395.031 92.874v133.221L220.729 351.753 50.904 226.224V92.747Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.781 96.951 220.87-21.794 384.151 97.071V221.82L220.869 339.484 61.781 221.939V96.951Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.66 101.154 221.012-9.526l152.262 110.793v116.274L221.011 327.215 72.661 217.653V101.154Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.54 105.359 221.153 2.744l141.242 102.719v107.801L221.154 314.946 83.539 213.368V105.359Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.416 109.563 126.878-94.55 130.223 94.646v99.328l-130.223 93.69-126.878-93.594v-99.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.295 113.767 116.141-86.484 119.203 86.572v90.855l-119.203 85.698-116.141-85.61v-91.031Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.174 117.97 105.405-78.418 108.183 78.498v82.383l-108.184 77.705-105.404-77.626V117.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.051 122.175 94.668-70.354 97.163 70.425v73.91l-97.164 69.713-94.667-69.642v-74.052Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.93 126.379 83.931-62.288 86.144 62.351v65.437L221.861 253.6l-83.931-61.658v-65.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.809 130.582 73.194-54.223 75.124 54.278v56.964l-75.124 53.729-73.194-53.674v-57.074Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.686 134.786 62.457-46.157 64.104 46.204v48.491l-64.104 45.737-62.457-45.69v-48.585Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.564 138.991 51.722-38.093 53.084 38.131v40.018l-53.085 37.746-51.721-37.708v-40.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.443 143.194 40.985-30.027 42.064 30.057v31.545l-42.064 29.754-40.985-29.724v-31.605Z"
  }))));
};
export default SvgModalBackground;